export default __webpack_public_path__ + "static/swell_chat-5ec15bfe0a30684f66a54117c9eca89d.mp4";